import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpLastSeenRank implements ICommand
{

	public Rank : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Rank = ba.readUint16();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.Rank);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpLastSeenRank();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Rank(W)='+this.Rank+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50141;
	}

	public getCmdName() : string
	{
		return 'SpLastSeenRank';
	}

}
